"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Creates an element className string by appending the appendingClassName (bem) to both the
 * baseClassName (component className) and the customClassNames (via the component's className
 * prop)
 * @param  {String} baseClassName      Typically the component's name
 * @param  {String} customClassNames   Classname passed to the component via props (multiple
 *                                     separated by spaces)
 * @param  {String} appendingClassName BEM - the element and/or modifier section of the class
 * @return {String}                    The complete className for the element
 */
var createClassName = function createClassName(baseClassName, customClassNames, appendingClassName) {
  if (!baseClassName) {
    return '';
  }
  var ownAppendingClassName = appendingClassName !== null && appendingClassName !== void 0 ? appendingClassName : '';
  var initialClassName = "".concat(baseClassName).concat(ownAppendingClassName);
  if (customClassNames) {
    var customClassNamesArr = customClassNames.replace(/\s\s+/g, ' ').split(' ');
    return customClassNamesArr.reduce(function (className, customClassName) {
      return "".concat(className, " ").concat(customClassName).concat(ownAppendingClassName);
    }, initialClassName);
  }
  return initialClassName;
};
var _default = exports.default = createClassName;